import { render, staticRenderFns } from "./VuesticTooltip.vue?vue&type=template&id=18a14a83&scoped=true"
import script from "./VuesticTooltip.vue?vue&type=script&lang=js"
export * from "./VuesticTooltip.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18a14a83",
  null
  
)

export default component.exports


//////////////////
// WEBPACK FOOTER
// ./src/vuestic-theme/vuestic-components/vuestic-tooltip/VuesticTooltip.vue
// module id = xQQC
// module chunks = 41